exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dyna-app-footer-links {\n  text-align: center;\n  padding: 8px 16px;\n}\n.dyna-app-footer-links a {\n  display: inline-block;\n  margin: 16px;\n  text-decoration: none;\n}\n", ""]);

// exports
